__turbopack_context__.v({
  "bubble": "styles-module__dtffMq__bubble",
  "bubble-wrapper": "styles-module__dtffMq__bubble-wrapper",
  "children-wrapper": "styles-module__dtffMq__children-wrapper",
  "content-wrapper": "styles-module__dtffMq__content-wrapper",
  "grow": "styles-module__dtffMq__grow",
  "image-rounded-wrapper": "styles-module__dtffMq__image-rounded-wrapper",
  "outer-wrapper": "styles-module__dtffMq__outer-wrapper",
  "rotate": "styles-module__dtffMq__rotate",
});
